import * as React from 'react';
import { Tooltip } from "../Tooltip";

import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleUnknown from "src/assets/images/lifecycle-unknown.png";

const DisplayLifeCycleRisk = (props) => {
    const { single_product } = props;
    return (
        <>
            {single_product && single_product.LifeCycleRisk !== undefined &&
                <>
                    {single_product.LifeCycleRisk === 'Low' &&
                        <Tooltip
                            position={'right center'}
                            opener={() => (
                                <div className="datasheet d-inline-flex w-100">
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                    ><img src={lifecyclegreen}
                                        className="lifecycle-icon-green"
                                        style={{ height: '16px', width: 'auto', display: 'inline' }} /><span
                                            className="txt">Lifecycle</span>
                                    </span>
                                </div>
                            )}
                            content={() => (
                                <>
                                    Low Risk: Part listed as active from Manufacturer. Suitable for new and existing designs.
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === 'Med' &&
                        <Tooltip
                            position={'right center'}
                            opener={() => (
                                <div className="datasheet d-inline-flex w-100">
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                    ><img src={lifecycleyellow}
                                        className="lifecycle-icon-yellow"
                                        style={{ height: '16px', width: 'auto', display: 'inline' }} /><span
                                            className="txt">Lifecycle</span>
                                    </span>
                                </div>
                            )}
                            content={() => (
                                <>
                                    Medium Risk: Part not confirmed as active by the Manufacturer. Presents increase risk of
                                    obsolescence. Exercise caution in using for a new design.
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === 'High' &&
                        <Tooltip
                            position={'right center'}
                            opener={() => (
                                <div className="datasheet d-inline-flex w-100">
                                    <span className="lifecycle low-risk cursor-default"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                    ><img src={lifecyclered}
                                        className="lifecycle-icon-red"
                                        style={{ height: '16px', width: 'auto', display: 'inline' }} /><span
                                            className="txt">Lifecycle</span>
                                    </span>
                                </div>
                            )}
                            content={() => (
                                <>
                                    High Risk: Part identified as End Of Life (EOL) or obsolete by "the" Manufacturer. Select an
                                    alternative from the list on part detail page or use part attribute filters to find
                                    alternative parts.
                                </>
                            )}
                        />
                    }
                    {single_product.LifeCycleRisk === null &&
                        <Tooltip position={'right center'}
                            opener={() => (
                                <div className="datasheet d-inline-flex w-100">
                                    <span className="lifecycle low-risk"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        data-html="true"
                                        data-title="Unknown:<br/>Lifecycle information not available.">
                                        <img src={lifecycleUnknown} className="lifecycle-icon-yellow" />
                                        <span className="txt">Lifecycle</span>
                                    </span>
                                </div>
                            )}
                            content={() => (
                                <>
                                    Unknown: Lifecycle information not available.
                                </>
                            )}
                        />
                    }
                </>
            }
        </>
    );
}

export default DisplayLifeCycleRisk;